import { render, staticRenderFns } from "./MailComposer.vue?vue&type=template&id=b50f2ada"
import script from "./MailComposer.vue?vue&type=script&lang=js"
export * from "./MailComposer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports